import React from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import userAvatar from 'src/app/images/user-avatar.svg';
import { CardProgressWrapper } from '@/components/ui/card';

export default function DataGridGenerated({ users, setNameOrder, nameOrder, setDateOrder, dateOrder, setParam }) {
  return (
    <div className="round-dg-wrapper">
      <table
        className="round-dg round-dg--light"
        style={{ minWidth: 800 }}
      >
        <thead className="round-dg__header">
          <tr className="round-dg__row">
            <th className="round-dg__cell-header round-dg__cell-header--sm">
              Nome e e-mail{' '}
              <span className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer">
                {nameOrder === 'descendent' ? (
                  <FiChevronDown
                    onClick={() => {
                      setNameOrder('ascendent');
                      setParam('name');
                    }}
                    className="card__icon"
                  />
                ) : (
                  <FiChevronUp
                    onClick={() => {
                      setParam('name');
                      setNameOrder('descendent');
                    }}
                    className="card__icon"
                  />
                )}
              </span>
            </th>
            <th className="round-dg__cell-header round-dg__cell-header--sm">CPF</th>
            <th className="round-dg__cell-header round-dg__cell-header--sm">GRE</th>
            <th className="round-dg__cell-header round-dg__cell-header--sm">Insitutição</th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 100 }}
            >
              Turma
            </th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 126 }}
            >
              Último acesso{' '}
              <span className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer">
                {dateOrder === 'descendent' ? (
                  <FiChevronDown
                    onClick={() => {
                      setDateOrder('ascendent');
                      setParam('last-access');
                    }}
                    className="card__icon"
                  />
                ) : (
                  <FiChevronUp
                    onClick={() => {
                      setDateOrder('descendent');
                      setParam('last-access');
                    }}
                    className="card__icon"
                  />
                )}
              </span>
            </th>
            <th
              className="round-dg__cell-header round-dg__cell-header--sm"
              style={{ width: 130 }}
            >
              % de conclusão
            </th>
          </tr>
        </thead>

        <tbody className="round-dg__body">
          {users.map((item, key) => (
            <tr
              className="round-dg__row"
              key={key}
            >
              <td className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                <div className="round-dg__user">
                  <img
                    className="avatar avatar--xs"
                    src={item['image-url'] || userAvatar}
                    alt="Imagem do usuário"
                  />

                  <div className="round-dg__user-inner">
                    <h3 className="round-dg__title">{item.name}</h3>
                    <p className="round-dg__subtitle">{item.email}</p>
                  </div>
                </div>
              </td>
              <td className="round-dg__cell round-dg__cell--sm">{item?.cpf ?? '--'}</td>
              <td className="round-dg__cell round-dg__cell--sm">{item?.regional_name}</td>
              <td className="round-dg__cell round-dg__cell--sm">
                <span className="u-text-truncate">{item.institution}</span>
              </td>
              <td className="round-dg__cell round-dg__cell--sm">{item.classroom}</td>
              <td className="round-dg__cell round-dg__cell--sm">{item['last-access'] ? new Date(item['last-access']).toLocaleDateString('pt-br') : '-'}</td>
              <td className="round-dg__cell round-dg__cell--sm">
                <CardProgressWrapper percentage={item['course-progress']} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
